import { render, staticRenderFns } from "./EndorsementDialog.vue?vue&type=template&id=6721af20&scoped=true&"
import script from "./EndorsementDialog.vue?vue&type=script&lang=ts&"
export * from "./EndorsementDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EndorsementDialog.vue?vue&type=style&index=0&id=6721af20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6721af20",
  null
  
)

export default component.exports